import React from "react";
import ContactUs from "./components/contact-us/ContactUs";

const ContactUsPage = () => {
  return (
    <div>
      <ContactUs />
    </div>
  );
};

export default ContactUsPage;
